import React, { useRef, useState, useEffect } from "react";
import { Form } from "react-bootstrap";

import { ICON_LABELS } from "../../constants";

const Correlation = ({
  correlation,
  updateCorrelationConfig,
  currentConfig,
}) => {
  const checkRef = useRef(null);
  const [checked, setChecked] = useState(correlation?.default);
  useEffect(() => {
    setChecked(currentConfig || false);
  }, [currentConfig]);
  return (
    <div className="correlationContainer">
      <div className="correlationHeader">
        <div className="correlationHeaderInfo">
          <div className="correlationTitle">Enable Correlation</div>
        </div>
      </div>
      <div className="formWrapper">
        <Form.Check
          ref={checkRef}
          type="switch"
          id="default-check"
          checked={checked}
          onChange={(event) => {
            if (event?.target?.checked) {
              updateCorrelationConfig({
                iconName: correlation?.iconName,
                onClick: correlation.onClick,
                onUnClick: correlation.onUnClick,
              });
            } else {
              updateCorrelationConfig(null);
            }
            setChecked(event?.target?.checked);
          }}
          label={ICON_LABELS[correlation?.iconName] ?? correlation?.iconName}
        />
      </div>
    </div>
  );
};
export default Correlation;
